/**
 * 懒加载：支持图片，普通音频，带source的音频，视频
 * 使用方式：
 * 图片：<img v-lazy="图片地址" src="占位图 />
 * 音频：<audio v-lazy="音频地址" src="占位图" controls />
 * 音频（带source）：<video v-lazy="音频地址" src="占位图" controls><source type="audio/mpeg" /></video>
 * 视频：<video v-lazy="视频地址" src="占位图" controls />
 * 时评（带source）：<video v-lazy="视频地址" src="占位图" controls><source type="video/mp4" /></video>
 */
export default {
  mounted(el, binding) {
    // 存储真实资源地址
    const realSrc = binding.value
    if (!realSrc) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 图片懒加载
            if (el.tagName === 'IMG') {
              el.src = realSrc
              observer.unobserve(el)
            } else if (['AUDIO', 'VIDEO'].includes(el.tagName)) {
              // 音频，视频 懒加载
              const source = el.querySelector('source')
              if (source) {
                source.src = realSrc
                observer.unobserve(el)
                // 修改source后必须调用load()触发加载
                el.load()
              } else {
                el.src = realSrc
              }
              observer.unobserve(el)
            }
          }
        })
      },
      {
        rootMargin: '60px 0px', // 提前 60px 加载
        // threshold: 0.1   // 元素10%进入视口即触发
      }
    )
    observer.observe(el)

    // 存储observer到元素上，方便卸载时清理
    el._lazyObserver = observer
  },

  unmounted(el) {
    if (el._lazyObserver) {
      el._lazyObserver.unobserve(el)
      el._lazyObserver.disconnect()
      delete el._lazyObserver
    }
  },
}
